// extracted by mini-css-extract-plugin
module.exports = {"container":"VideoGrid_container__1eUpe"};